
已发布的文章页面
<template>
  <div class="completedCon">
    <!-- 上部导航 -->
    <div class="topNav">
    </div>
    <!-- 下部内容 -->
    <div class="contentList">
      <el-table
        :data="tableData.filter(data => !search || data.title.toLowerCase().includes(search.toLowerCase()))"
        class="el-table"
        :stripe=true
        :border=true
        :height="600"
        :default-sort = "{prop: 'date', order: 'descending'}">
        <!-- 1 -->
        <el-table-column
          label="文章新建日期"
          prop="date"
          sortable
          width="300px"
        >
        </el-table-column>
        <el-table-column
          label="发布日期"
          prop="time"
          width="300px"
        >
        </el-table-column>
        <!-- 3 -->
        <el-table-column
          label="文章名"
          prop="title"
          sortable
        >
        </el-table-column>
        <!-- 4 -->
        <el-table-column
          align="right"
          width="300px">
          <template slot="header" slot-scope="scope">
            <el-input
              v-model="search"
              size="mini"
              placeholder="输入关键字搜索"/>
              {{scope.row ? '' : ''}}
          </template>
          <template slot-scope="scope">
            <el-button
              size="small"
              type="primary"
              @click="handleEdit(scope.$index, scope.row)">修改文章</el-button>
            <el-button
              size="small"
              type="danger"
              @click="deleteHandle(scope.row.id,scope.row.title,scope.row.url)">删除文章</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagi"
        background
        layout="prev, pager, next, sizes, total"
        :total="paginationConfig.total"
        :page-sizes="paginationConfig.pageSizesOptions"
        :page-size="paginationConfig.pageSize"
        :current-page.sync="paginationConfig.currentPage"
        @size-change="sizeChange"
        @current-change="getNewsData"
        >
      </el-pagination>
    </div>

  </div>
</template>

<script>
import api from '@/api'
export default {
  data() {
        return {
          tableData: [],//文章信息
          search: '',
          paginationConfig: {
            total: 0,
            pageSizesOptions: [ 20, 50, 100 ],
            currentPage: 1,
            pageSize: 20,
          }
        }
  },

  created(){
    this.getNewsData()
  },

  methods: {
    //修改
    handleEdit(index, row) {
      row.sign = 'modify'
      this.$confirm('即将跳转到编辑页面,新编辑内容会覆盖之前的内容，是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push({
              name:'editingArticles',
              query: {
                id: row.id,
                sign: row.sign
              }
          })
         
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });          
        });
      
    },
    
    //弹框  删除
    deleteHandle(id,title,url) {
        this.$confirm(`是否确认删除文章：${title}, 是否继续?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          api.deleteHandle(id,url)
            .then(res => {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                
                location.reload()
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },

    sizeChange(value) {
      this.paginationConfig.pageSize = value
      this.getNewsData()
    },
      //获取最新的新闻列表
    getNewsData(){
      let paramObj = {
        a: '1',
        author: 2,
        pageSize: this.paginationConfig.pageSize,
        pageNow: this.paginationConfig.currentPage
      }
      api.getNewsListData(paramObj)
          .then(res => {
            // console.log(res.data.data.list)
            let newsData = res.data.data.list
            this.tableData = []
            this.paginationConfig.total = res.data.data.count
            newsData.forEach(item => {
              Object.keys(item).forEach(key => {
                if(item[key] == null || item[key] == undefined) {
                  item[key] = ''
                }
              })
              item.date = item.creation_time
              
              this.tableData.push(item)
            });
            // console.log(this.tableData)
          })
    }
    
  },
    
}
</script>

<style scoped lang="scss">
    .completedCon{
        background: #fff;
        .contentList{
          padding:20px;

          .pagi {
            padding: 20px;
          }
        }
        
    }
</style>